export default __webpack_public_path__ + "static/media/Photo_me2.441e0d5d.jpg";